import { LitElement, css, html } from 'lit'



export class DzSingleSlide extends LitElement {

    static get properties() {
        return {
          currentItem: { type: String },
          duration: { type: String }        // свойство для выбора карточки
        }
    }

    constructor() {
        super()
        this.currentItem = ""
        this.duration = "0.3s"
    }

    updated(changes) {
        if (changes.get("currentItem")) {
            let f_slot = this.renderRoot.getElementById("first-slot")
            let s_slot = this.renderRoot.getElementById("second-slot")
            let slider = this.renderRoot.getElementById("slider")
    
            s_slot.name = changes.get("currentItem")
            f_slot.name = this.currentItem
            slider.style.animation = `${this.duration} slide_down`
            slider.onanimationend = () => {
                slider.style.animation = `none`
                f_slot.name = "undefined"
                s_slot.name = this.currentItem
            }
        } 
    }

    render() {
      return html`
            <div id="slider">
                <slot id="first-slot" name="default"><div class="default">&nbsp;</div></slot>
                <slot id="second-slot" name="${this.currentItem}"></slot>
            </div>
        `
    }

    static get styles() {
      return css`
          :host {
            display: inline-block;
            box-sizing: border-box;
            overflow: hidden;
            position: relative;
          }

          #slider {
            position: absolute;
            flex-direction: column;
            width: 100%;
            height: 200%;
            left: 0px;
            top: -100%;
          }

          .default {
            width: 100%;
            height: 50%;
          }

          ::slotted(*) {
            box-sizing: border-box;
            height: 50% !important;
            width: 100% !important;
            margin: 0;
            top: 0px;
            left: 0px;
          }

          @keyframes slide_down {
            from {
                top: -100%;
            }
            to {
                top: 0px;
            }
          }
      `
    }
}

window.customElements.define('dz-single-slide', DzSingleSlide)